<template>
  <div
    class="root relative"
    v-bind:class="{ focused, disabled, 'px-1': !disabled, highlight, 'has-error': error }"
    @click="onClick"
  >
    <span v-if="!value" style="pointer-events: none;">
      <slot name="placeholder">
        <span class="grey--text text--lighten-1" v-html="placeholder || '&nbsp;'" />
      </slot>
    </span>
    <slot v-if="!$slots.placeholder || value">
      <span
        ref="content"
        v-bind:class="{ 'absolute-fill': !value }"
        :contenteditable="disabled ? false : 'plaintext-only'"
        @input="e => $emit('input', e.target.innerText)"
        @focusin="focused = true"
        @focusout="focused = false"
        @click.stop
      />
    </slot>
    <slot name="suffix"></slot>
  </div>
</template>


<style scoped>
.root:not(.disabled) {
  min-width: 72px;
}
.root:not(.focused):not(.disabled) {
  cursor: pointer;
}
.root:before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 4px;
}
.root.focused:not(.disabled):before {
  outline: 2px solid rgb(34,120,207);
}
.root:not(.focused):not(.disabled):hover:before {
  outline: 1px solid rgb(0,0,0,.86);
}
.root.has-error:not(.disabled):before,
.root.focused.has-error:not(.disabled):before,
.root.focused.has-error:not(.disabled):hover:before,
.root.has-error:not(.focused):not(.disabled):hover:before {
  outline: 2px solid #ff5252;
}
.root.highlight:not(.focused):not(.disabled):before {
  background-color: rgba(34,120,207,.08);
  outline: 1px solid rgb(34,120,207);
}
.root.has-error.highlight:not(.focused):not(.disabled):before {
  background-color: rgba(236,95,89,.08);
}
.root [contenteditable]:focus {
  outline: 0 solid transparent;
}
</style>


<script>
export default {
  name: 'content-editable-div',

  props: [ 'placeholder', 'disabled', 'value', 'highlight', 'error' ],

  data() {
    return {
      focused: false
    };
  },

  methods: {
    async onClick() {
      await this.$nextTick();
      if (this.$refs.content) {
        const sel = window.getSelection();
        sel.selectAllChildren(this.$refs.content);
        sel.collapseToEnd();
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      async handler(v) {
        await this.$nextTick();
        if (!this.$refs.content)
          return;
        if (this.$refs.content.innerText != v)
          this.$refs.content.innerText = v || '';
      }
    }
  }
}
</script>
